<template>
<v-card :class="{'my-3':true,'mx-3':$vuetify.breakpoint.smAndUp}" outlined>

    <v-card-title>
        <v-row no-gutters align="center">
            {{$t('sheet_room_meal.sheet_components.rooms.title')}}
            <v-spacer />
            <div>
                <v-btn depressed :small="$vuetify.breakpoint.smAndDown" color="primary" class="ma-1" @click="$emit('bulkRoom')">
                    <v-icon class="pr-1">hotel</v-icon>
                    {{$t('sheet_room_meal.button.rooms')}}
                </v-btn>
            </div>
        </v-row>
    </v-card-title>
    <v-divider class="mx-4" />
    <v-card-text class="sheet-wrapper" ref="sheet-wrapper" @scroll="$emit('scroll', 'room')" @mouseover="$emit('select', 'room')">

        <table class="sheet sheet-highlight">

            <colgroup>
                <col />
                <col v-for="(day, index) in days" :key="'day' + index" :class="column_class(day)" />
            </colgroup>

            <thead>
                <tr class="white">
                    <th></th>
                    <th v-for="(day, index) in days" :key="'month' + index" class="sheet-date text-capitalize pa-1" :style="{ backgroundColor: !month(day) ? 'transparent' : 'white'}">
                        {{ month(day) }}
                    </th>
                </tr>
                <tr>
                    <th class="sheet-header text-center" style="border-top: 1px solid white; border-left: 1px solid white;"></th>
                    <th v-for="(day, index) in days" :key="index" class="sheet-cell" style="border-top: 2px solid rgba(0, 0, 0, .1);">
                        {{ $moment(day).locale($vuetify.lang.current).format('ddd') }} {{ $moment(day).format('D') }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <template v-for="room in room_types">
                    <room-type :room="room" :days="days" :prices="sheet.room_types[room.id]"></room-type>
                </template>
            </tbody>

        </table>

    </v-card-text>

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import RoomType from './SheetRows/RoomType.vue';

export default {
    components: {
        "room-type": RoomType,

    },
    name: `sheet`,

    props: {
        weekend: Array,
        days: Array,
        room_types: Array,
        sheet: Object,
        edited_sheet: Object
    },
    data() {
        return {
            meal_types: ["breakfast", "lunch", "dinner", "all-inclusive"],

        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        column_class: function (day) {
            return {
                weekday: true,
                weekend: this.weekend.map(Number)
                    .includes(this.$moment(day)
                        .weekday())
            }
        },

        month: function (day) {
            let month_start = this.$moment(day)
                .startOf('day');
            if(month_start.format('YYYY-MM-DD') === this.days[0]) return this.$moment(month_start)
                .locale(this.$vuetify.lang.current)
                .format('MMM YYYY');
            if(month_start.format('YYYY-MM-DD') === month_start.clone()
                .startOf('month')
                .format('YYYY-MM-DD')) return this.$moment(month_start)
                .locale(this.$vuetify.lang.current)
                .format('MMM YYYY');
            return null;
        },

    },
}
</script>
